import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { inventoryAPI } from '../../services';
import { toast } from 'react-toastify';

const RejectImportRequestModal = ({ show, request, currentUserId, onHide, onSuccess }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) setReason('');
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!request || !currentUserId) return;
    setLoading(true);
    try {
      await inventoryAPI.rejectImportRequest(request.id, currentUserId, reason.trim() || undefined);
      toast.success(`Đã từ chối phiếu ${request.request_number}`);
      onSuccess?.();
      onHide();
    } catch (err) {
      toast.error(err?.message || 'Từ chối thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Từ chối phiếu nhập kho</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {request && (
            <p className="text-muted small mb-3">
              Phiếu <strong>{request.request_number}</strong> — {request.branch?.name}
            </p>
          )}
          <Form.Group>
            <Form.Label>Lý do từ chối (tùy chọn)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Nhập lý do từ chối..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>Hủy</Button>
          <Button type="submit" variant="danger" disabled={loading}>
            {loading ? <Spinner size="sm" /> : 'Xác nhận từ chối'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RejectImportRequestModal;
